export default Object.freeze({
  TRUSTED_SCREENING_VOTE: 'TRUSTED_SCREENING_VOTE',
  TRUSTED_FULL_TEXT_REVIEW: 'TRUSTED_FULL_TEXT_REVIEW',
  TRUSTED_DATA_EXTRACTION: 'TRUSTED_DATA_EXTRACTION',
  RESOLVE_SCREENING_CONFLICT: 'RESOLVE_SCREENING_CONFLICT',
  RESOLVE_FULL_TEXT_REVIEW_CONFLICT:
    'RESOLVE_FULL_TEXT_REVIEW_CONFLICT',
  RESOLVE_DATA_EXTRACTION_CONFLICT:
    'RESOLVE_DATA_EXTRACTION_CONFLICT',
});
